import {axiosRequest} from "../api";
import {API_PATH} from "../../constants";

export const AllergyReactionService = {
  getAllergyReactionsList(params){ return axiosRequest('GET', API_PATH.ALLERGY_REACTION.LIST(params)) },
  getAllergyReaction(data){ return axiosRequest('POST', API_PATH.ALLERGY_REACTION.INFO, data) },
  addAllergyReaction(data){ return axiosRequest('POST', API_PATH.ALLERGY_REACTION.ADD, data) },
  deleteAllergyReaction(data){ return axiosRequest('POST', API_PATH.ALLERGY_REACTION.DELETE, data) },
}